// Module
var code = "<span></span>";
// Exports
module.exports = code;